<div class="d-flex justify-content-center mb-2">
  <web-components-trading-session (authorizationState)="sessionAuthState($event)" />
</div>
<div class="d-flex justify-content-center mb-2">
  <web-design-system-button size="small" (click)="confirm()" [disabled]="sessionAuthorized !== true">Streichen</web-design-system-button>
  <web-design-system-button size="small" type="secondary" class="ml-2" (click)="abort()">Abbrechen</web-design-system-button>
</div>
<div #scrollintoviewElement>
  <web-components-user-messages />
</div>
